import './index.css'
import * as React from 'react'

export default class Login extends React.Component<any> {
  render(): React.ReactElement<'div'> {
    const displayClass = navigator.cookieEnabled ? '' : 'is-visible'
    return (
      <div className={`CookiesDisabled ${displayClass}`}>
        <p>
          It looks like you have cookies disabled. You will need to enable them
          to use DISCO. <br />
          See here for{' '}
          <a
            href="https://support.google.com/accounts/answer/61416?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chrome
          </a>
          ,{' '}
          <a
            href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firefox
          </a>
          ,{' '}
          <a
            href="https://support.apple.com/kb/PH19214?locale=en_US"
            target="_blank"
            rel="noopener noreferrer"
          >
            Safari
          </a>
          ,{' '}
          <a
            href="http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies"
            target="_blank"
            rel="noopener noreferrer"
          >
            Internet Explorer
          </a>
          .
        </p>
      </div>
    )
  }
}
